import {UI_GROUP_TYPE_HORIZONTAL, UI_GROUP_TYPE_VERTICAL, UI_GROUP_TYPE_WEB_ONLY_HORIZONTAL} from "../constants";
import getDynamicItemFor from "../selected/DynamicItemMapper";

export const DynamicUiGroup = ({section: {sub_type: subType, sections}, mobile = true}) => {

  return (
    <div
      className={`app-side-pd flex flex-grow items-start ${subType === UI_GROUP_TYPE_HORIZONTAL || (subType === UI_GROUP_TYPE_WEB_ONLY_HORIZONTAL && !mobile) ? 'space-x-3' : 'flex-col space-y-2'}`}>

      {sections?.map((sec) => getDynamicItemFor(sec, {key: `group-ui-${sec.id}`, pdClass: "", mobile:mobile}))}
    </div>
  );
};